import { render, staticRenderFns } from "./FilterChips.vue?vue&type=template&id=87bb0bc6&"
import script from "./FilterChips.vue?vue&type=script&lang=js&"
export * from "./FilterChips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87bb0bc6')) {
      api.createRecord('87bb0bc6', component.options)
    } else {
      api.reload('87bb0bc6', component.options)
    }
    module.hot.accept("./FilterChips.vue?vue&type=template&id=87bb0bc6&", function () {
      api.rerender('87bb0bc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/whitelist/components/FilterChips.vue"
export default component.exports